import { insuranceTerms } from "@docio/shared";
import { LegalDocumentPage } from "@/components/LegalDocumentPage";

const InsuranceTerms = () => (
  <LegalDocumentPage
    doc={insuranceTerms}
    seoTitle="Insurance Provider Terms"
    seoDescription="The Platform-Medical Assistance Company Terms of Service governing insurance and assistance companies booking care through Docio Health."
    chromeKey="insuranceTerms"
    banner={{
      textKey: "insuranceTerms.hubBanner.text",
      ctaKey: "insuranceTerms.hubBanner.cta",
      to: "/legal",
    }}
  />
);

export default InsuranceTerms;
